import { Component, OnInit } from '@angular/core';
import { config, MemberQuery, AnnouncementService } from '@fgb/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  config = config;
  name$: Observable<string>;

  constructor(
    private memberQuery: MemberQuery,
    private announcementService: AnnouncementService
  ) { }

  ngOnInit() {
    this.announcementService.fetchAnnouncements().toPromise();
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `WELCOME, ${m.FirstName}`;
        }
        return '';
      })
    );
  }
}
